// extracted by mini-css-extract-plugin
module.exports = {"SaleDetailsForm":"SaleDetailsForm_SaleDetailsForm__1wl1Z","flightInfo":"SaleDetailsForm_flightInfo__R8Iaf"};